"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _toConsumableArray2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es6.regexp.replace");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _utils = require("@/utils");
var _acceesorySitc = _interopRequireDefault(require("@/componentsBuz/Accessory/acceesorySitc.vue"));
var _SailSchedule = _interopRequireDefault(require("@/components/SailSchedule"));
var _SailScheduleTS = _interopRequireDefault(require("@/components/SailScheduleTS"));
var _SailScheduleLane = _interopRequireDefault(require("@/components/SailScheduleLane"));
var _vuex = require("vuex");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    sailSchedule: _SailSchedule.default,
    acceesorySitc: _acceesorySitc.default,
    sailScheduleLane: _SailScheduleLane.default,
    sailScheduleOne: _SailScheduleTS.default
  },
  props: {
    isSupplyDisabled: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object
    },
    rules: {
      type: Object
    },
    lineTypeList: {
      type: Array
    },
    serviceLineCodeList: {
      type: Array
    },
    directionList: {
      type: Array
    },
    showdisabled: {
      type: Boolean,
      default: false
    },
    packageDescList: {
      type: Array
    },
    packageTypeList: {
      type: Array
    },
    contactTypeCodeList: {
      type: Array
    },
    containerTypeList: {
      type: Array
    },
    containerSizeList: {
      type: Array
    },
    fullEmptyTypeList: {
      type: Array
    },
    isFeed: {
      type: Boolean,
      default: true
    },
    copy: {
      type: String,
      default: ''
    },
    preLockFlag: {
      type: Boolean,
      default: null
    },
    adjustVesselFlag: {
      type: Boolean,
      default: null
    },
    isDisable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      initDirection: 0,
      pickerOptions: {
        disabledDate: function disabledDate(time) {},
        shortcuts: [{
          text: this.$t('home.newToday'),
          onClick: function onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }]
      },
      sailScheduleDialogVisible: false,
      bkRoutingSailScheduleDialogVisible: false,
      sailScheduleLaneDialogVisible: false,
      fullEmptyTypeListType: [{
        value: 1,
        labelEh: 'Horizontal bar',
        labelZh: '单杠'
      }, {
        value: 2,
        labelEh: 'Parallel bars',
        labelZh: '双杠'
      }],
      rateBaseList: [{
        value: 'C',
        labelZh: '摄氏度',
        labelEh: 'C'
      }, {
        value: 'F',
        labelZh: '华氏度',
        labelEh: 'F'
      }, {
        value: null,
        labelZh: '',
        labelEh: ''
      }],
      isSplitList: [{
        value: 0,
        labelEh: 'NO',
        labelZh: '否'
      }, {
        value: 1,
        labelEh: 'YES',
        labelZh: '是'
      }],
      rateBaseListOne: [{
        value: 'C',
        labelZh: 'C',
        labelEh: 'C'
      }, {
        value: 'F',
        labelZh: 'F',
        labelEh: 'F'
      }]
    };
  },
  watch: {
    'form.socCheckFlag': function formSocCheckFlag(newVal) {
      if (newVal === 1) {
        this.initDirection = this.form.webBkSocComs.some(function (val) {
          return val.direction === 1;
        }) ? 1 : 0;
      }
    }
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  methods: {
    formatTempNum: function formatTempNum(value, index) {
      if (value) {
        this.form.webBkReeferComs[index].temperature = value.replace(/[^\d.+\-]/g, '');
      }
      if (value > 9999999.99) {
        if (value.startsWith('+')) {
          this.form.webBkReeferComs[index].temperature = '+' + 9999999.99;
        } else {
          this.form.webBkReeferComs[index].temperature = 9999999.99 + '';
        }
      }
      if (value < -9999999.99) {
        this.form.webBkReeferComs[index].temperature = -9999999.99 + '';
      }
    },
    onKeyUp: function onKeyUp(value, index) {
      if (value) {
        var len = null;
        if (value.toString().split('.')[1]) {
          len = value.toString().split('.')[1].length;
        }
        // event.returnValue = (2 === len) ? false: event.returnValue
        if (len >= 2) {
          this.form.webBkReeferComs[index].temperature = this.form.webBkReeferComs[index].temperature.substring(0, value.toString().indexOf('.') + 3);
        }
      }
    },
    tempBlur: function tempBlur(value, index) {
      if (value) {
        var temp = parseFloat(event.target.value);
        //.toFixed(2)
        if (value.startsWith('+')) {
          temp = '+' + temp;
        }
        this.form.webBkReeferComs[index].temperature = temp + '';
      }
    },
    headFullEmptyType: function headFullEmptyType(_ref) {
      var row = _ref.row,
        column = _ref.column,
        rowIndex = _ref.rowIndex,
        columnIndex = _ref.columnIndex;
      if (columnIndex === 6 && this.initDirection === 1) {
        return 'color:#FF5967!important';
      }
    },
    parseTime: _utils.parseTime,
    changeLine: function changeLine(val) {
      if (val === 0) {
        this.form.webBkRoutingComs[this.currentIndexPort].serviceLineCode = 'T/S';
        this.form.webBkRoutingComs[this.currentIndexPort].vesselCode = 'T/S';
        this.form.webBkRoutingComs[this.currentIndexPort].vesselName = 'T/S';
        this.form.webBkRoutingComs[this.currentIndexPort].voyageNo = 'T/S';
        this.form.webBkRoutingComs[this.currentIndexPort].voyageLeg = 'T/S';
      }
      console.log('val中转', val);
    },
    handleFocus: function handleFocus(index) {
      console.log('focus', index);
      this.currentIndexPort = index;
    },
    changePortFrom: function changePortFrom(row, val) {
      console.log('row', row, val);
      this.form.webBkRoutingComs[this.currentIndexPort].portFromName = val.portName;
    },
    changePortTo: function changePortTo(row, val) {
      // console.log('row88888777',row,val,this.webBkRoutingComs[this.currentIndexPort])
      this.form.webBkRoutingComs[this.currentIndexPort].portToName = val.portName;
    },
    changeTsflag: function changeTsflag(val) {
      console.log('this.copy', this.copy);
      if (this.copy !== 'copy' && val == 1 && this.form.webBkRoutingComs.length === 0) {
        this.handleAddTransfer();
      } else {
        // this.form.webBkRoutingComs.length && this.form.webBkRoutingComs.forEach(item=>{
        //   if(item.bookingHeadWebComId || item.templateBookingHeadComId){
        //     item.rowStatus = 8
        //     this.form.deleteWebBkRoutingComs.push(item)
        //     }
        // })
        // this.form.webBkRoutingComs =[]
      }
    },
    changeDgCheckFlag: function changeDgCheckFlag(val) {
      var _this = this;
      if (val == 1 && this.form.webBkImoComs.length === 0) {
        this.handleAddTransferNew();
      } else {
        var nullData = [{
          classType: '',
          unSeriseNo: '',
          quantity: null,
          property: '',
          packageCode: '',
          emergencySeq: '',
          imoQuantity: null,
          grossWeight: null,
          netWeight: null,
          packagingCode: '',
          cargoSize: null,
          casNo1: 0,
          casNo2: 0,
          casNo3: 0,
          temperature: null,
          intakeNum: '',
          contactName: '',
          contactNumber: '',
          contactTypeCode: '',
          approveKey: '',
          id: '',
          rowStatus: 4,
          componentDesc: '',
          emergencyTelNo: ''
        }];
        if (val === 0 && JSON.stringify(this.form.webBkImoComs) !== JSON.stringify(nullData)) {
          this.$confirm(this.$t('home.deleteCheck1') + this.$t('home.dgCheckFlag') + this.$t('home.deleteCheck2'), this.$t('confirmMsg.title'), {
            confirmButtonText: this.$t('confirmMsg.confirm'),
            cancelButtonText: this.$t('confirmMsg.cancel'),
            type: 'warning'
          }).then(function () {
            _this.form.webBkImoComs.length && _this.form.webBkImoComs.forEach(function (item) {
              if (item.bkCargoWebComId || item.templateBkCargoComId) {
                item.rowStatus = 8;
                _this.form.deleteWebBkImoComs.push(item);
              }
            });
            _this.form.webBkImoComs = [];
          }).catch(function (err) {
            _this.form.dgCheckFlag = 1;
          });
        } else {
          this.form.webBkImoComs.length && this.form.webBkImoComs.forEach(function (item) {
            if (item.bkCargoWebComId || item.templateBkCargoComId) {
              item.rowStatus = 8;
              _this.form.deleteWebBkImoComs.push(item);
            }
          });
          this.form.webBkImoComs = [];
        }
      }
    },
    changeDgRfCheckFlagg: function changeDgRfCheckFlagg(val) {
      var _this2 = this;
      if (val == 1 && this.form.webBkReeferComs.length === 0) {
        this.handleAddwebBkReeferComs();
      } else {
        var nullData = [{
          rateBase: '',
          temperature: null,
          maxTemperature: null,
          minTemperature: null,
          intakeNum: null,
          humidity: null
        }];
        if (val === 0 && JSON.stringify(this.form.webBkReeferComs) !== JSON.stringify(nullData)) {
          this.$confirm(this.$t('home.deleteCheck1') + this.$t('home.rfCheckFlag') + this.$t('home.deleteCheck2'), this.$t('confirmMsg.title'), {
            confirmButtonText: this.$t('confirmMsg.confirm'),
            cancelButtonText: this.$t('confirmMsg.cancel'),
            type: 'warning'
          }).then(function () {
            _this2.form.webBkReeferComs.length && _this2.form.webBkReeferComs.forEach(function (item) {
              if (item.bkCargoWebComId || item.templateBkCargoComId) {
                item.rowStatus = 8;
                _this2.form.deleteWebBkReeferComs.push(item);
              }
            });
            _this2.form.webBkReeferComs = [];
          }).catch(function (err) {
            _this2.form.rfCheckFlag = 1;
          });
        } else {
          this.form.webBkReeferComs.length && this.form.webBkReeferComs.forEach(function (item) {
            if (item.bkCargoWebComId || item.templateBkCargoComId) {
              item.rowStatus = 8;
              _this2.form.deleteWebBkReeferComs.push(item);
            }
          });
          this.form.webBkReeferComs = [];
        }
      }
    },
    changeDgakCheckFlag: function changeDgakCheckFlag(val) {
      var _this3 = this;
      if (val == 1 && this.form.webBkAkComs.length === 0) {
        this.handleAddrfCheck();
      } else {
        var nullData = [{
          containerType: null,
          akLength: null,
          akWidth: null,
          akHigth: null,
          akGrossWeight: null,
          akNetWeight: null,
          quantity: null,
          commodityName: null,
          overFront: null,
          overAfter: null,
          overPortside: null,
          overStarboard: null,
          overHeight: null,
          isWallsFold: 0,
          isPointCover: 0,
          stowageRequired: null,
          specialLoadRequired: null,
          securingMethod: null,
          cellphone: null,
          oceanFreight: null,
          other: null
        }];
        if (val === 0 && JSON.stringify(this.form.webBkAkComs) !== JSON.stringify(nullData)) {
          this.$confirm(this.$t('home.deleteCheck1') + this.$t('home.akCheckFlag') + this.$t('home.deleteCheck2'), this.$t('confirmMsg.title'), {
            confirmButtonText: this.$t('confirmMsg.confirm'),
            cancelButtonText: this.$t('confirmMsg.cancel'),
            type: 'warning'
          }).then(function () {
            _this3.form.webBkAkComs.length && _this3.form.webBkAkComs.forEach(function (item) {
              if (item.bookingHeadWebComId || item.templateBookingHeadComId) {
                item.rowStatus = 8;
                _this3.form.deleteWebBkAkComs.push(item);
              }
            });
            _this3.form.webBkAkComs = [];
          }).catch(function (err) {
            _this3.form.akCheckFlag = 1;
          });
        } else {
          this.form.webBkAkComs.length && this.form.webBkAkComs.forEach(function (item) {
            if (item.bookingHeadWebComId || item.templateBookingHeadComId) {
              item.rowStatus = 8;
              _this3.form.deleteWebBkAkComs.push(item);
            }
          });
          this.form.webBkAkComs = [];
        }
      }
    },
    changeSocCheckFlag: function changeSocCheckFlag(val) {
      var _this4 = this;
      if (val == 1 && this.form.webBkSocComs.length === 0) {
        this.handleAddSoc();
      } else {
        var nullData = [{
          direction: '',
          returnToPort: '',
          returnToPortName: '',
          contactPerson: '',
          containerManager: 'SOC',
          fullEmptyType: '',
          containerSize: ''
        }];
        if (val === 0 && JSON.stringify(this.form.webBkSocComs) !== JSON.stringify(nullData)) {
          this.$confirm(this.$t('home.deleteCheck1') + this.$t('home.socCheckFlag') + this.$t('home.deleteCheck2'), this.$t('confirmMsg.title'), {
            confirmButtonText: this.$t('confirmMsg.confirm'),
            cancelButtonText: this.$t('confirmMsg.cancel'),
            type: 'warning'
          }).then(function () {
            _this4.form.webBkSocComs.length && _this4.form.webBkSocComs.forEach(function (item) {
              if (item.bookingHeadWebComId || item.templateBookingHeadComId) {
                item.rowStatus = 8;
                _this4.form.deleteWebBkSocComs.push(item);
              }
            });
            _this4.form.webBkSocComs = [];
          }).catch(function (err) {
            _this4.form.socCheckFlag = 1;
          });
        } else {
          this.form.webBkSocComs.length && this.form.webBkSocComs.forEach(function (item) {
            if (item.bookingHeadWebComId || item.templateBookingHeadComId) {
              item.rowStatus = 8;
              _this4.form.deleteWebBkSocComs.push(item);
            }
          });
          this.form.webBkSocComs = [];
        }
      }
    },
    changeHgCheckFlag: function changeHgCheckFlag(val) {
      var _this5 = this;
      if (val == 1 && this.form.webBkHgComs.length === 0) {
        this.handleAddHg();
      } else {
        var nullData = [{
          containerType: '',
          quantity: null,
          type: '',
          rope: null,
          ties: null
        }];
        if (val === 0 && JSON.stringify(this.form.webBkHgComs) !== JSON.stringify(nullData)) {
          this.$confirm(this.$t('home.deleteCheck1') + this.$t('home.hgCheckFlag') + this.$t('home.deleteCheck2'), this.$t('confirmMsg.title'), {
            confirmButtonText: this.$t('confirmMsg.confirm'),
            cancelButtonText: this.$t('confirmMsg.cancel'),
            type: 'warning'
          }).then(function () {
            _this5.form.webBkHgComs.length && _this5.form.webBkHgComs.forEach(function (item) {
              if (item.bookingHeadWebComId || item.templateBookingHeadComId) {
                item.rowStatus = 8;
                _this5.form.deleteWebBkHgComs.push(item);
              }
            });
            _this5.form.webBkHgComs = [];
          }).catch(function (err) {
            _this5.form.hgCheckFlag = 1;
          });
        } else {
          this.form.webBkHgComs.length && this.form.webBkHgComs.forEach(function (item) {
            if (item.bookingHeadWebComId || item.templateBookingHeadComId) {
              item.rowStatus = 8;
              _this5.form.deleteWebBkHgComs.push(item);
            }
          });
          this.form.webBkHgComs = [];
        }
      }
    },
    // 获取附件的信息
    handleGetFileList: function handleGetFileList() {
      var deleteList = this.$refs.acceesorySitc.deletefileKey || [];
      this.form.webBkImoComFiles = this.$refs.acceesorySitc.fileList || [];
      console.log(' this.form.webBkImoComFiles ,', this.form.webBkImoComFiles);
      console.log(' this.$refs.acceesorySitc.fileList', this.$refs.acceesorySitc.fileList, deleteList);
      this.form.webBkImoComFiles = [].concat((0, _toConsumableArray2.default)(this.form.webBkImoComFiles), (0, _toConsumableArray2.default)(deleteList));
    },
    handleAddFile: function handleAddFile() {
      this.$refs.acceesorySitc.dialogVisible = true;
    },
    changeReturnToPort: function changeReturnToPort(value, selectedRows) {
      this.form.webBkSocComs[this.currentIndex].returnToPortName = selectedRows.portName;
    },
    handleGetIndex: function handleGetIndex(index) {
      this.currentIndex = index;
    },
    handAddVesselInfo: function handAddVesselInfo(index) {
      this.currentIndex = index;
      this.sailScheduleDialogVisible = true;
    },
    handAddVesselLaneInfo: function handAddVesselLaneInfo(index) {
      this.currentIndex = index;
      if (1 == this.form.webBkRoutingComs[this.currentIndex].tripNumber && 1 == this.form.webBkRoutingComs[this.currentIndex].lineType) {
        this.bkRoutingSailScheduleDialogVisible = true;
        this.$refs.sailSchedule1.filterForm.pol = this.form.webBkRoutingComs[index].portFrom;
        this.$refs.sailSchedule1.filterForm.pod = this.form.webBkRoutingComs[index].portTo;
      } else {
        this.sailScheduleLaneDialogVisible = true;
        this.$refs.sailScheduleLane.filterForm.pol = this.form.webBkRoutingComs[index].portFrom;
        this.$refs.sailScheduleLane.filterForm.pod = this.form.webBkRoutingComs[index].portTo;
      }
    },
    selectionChange: function selectionChange(row) {
      var _this6 = this;
      this.sailScheduleDialogVisible = false;
      // this.form.singleContainerFlag = row.singleContainerFlag
      // this.form.webBkExtendComs[0].singleContainerFlag =  row.singleContainerFlag
      if (row.routeList && row.routeList.length > 0) {
        this.form.tsFlag = 1;
        var newData = row.routeList.map(function (item, index) {
          return {
            tripNumber: _this6.form.webBkRoutingComs.length + index + 1,
            lineType: Number(item.lineType),
            serviceLineCode: item.serviceLineCode,
            vesselCode: item.vesselCode,
            vesselName: item.vesselName,
            voyageNo: item.voyageNo,
            voyageLeg: item.voyageLeg,
            portFrom: item.polCode,
            portTo: item.podCode,
            etd: (0, _utils.parseTime)(item.etd, '{y}-{m}-{d} {h}:{i}:{s}'),
            eta: item.eta,
            carrier: item.carrier,
            portFromName: item.pol,
            portToName: item.pod
          };
        });
        this.form.webBkRoutingComs = [].concat((0, _toConsumableArray2.default)(this.form.webBkRoutingComs), (0, _toConsumableArray2.default)(newData));
      } else {
        this.handleAddTransfer();
        var data = this.form.webBkRoutingComs[this.currentIndex];
        data.vesselCode = row.vesselCode;
        data.vesselName = row.vesselName;
        data.voyageNo = row.voyageNo;
        data.voyageLeg = row.voyageLeg;
        data.tripNumber = row.tripNumber || this.currentIndex + 1;
        data.serviceLineCode = row.serviceLineCode;
        data.portFrom = row.polHidden;
        data.portTo = row.podHidden;
        data.portFromName = row.pol;
        data.portToName = row.pod;
        data.etd = row.etd;
        data.eta = row.eta;
        data.carrier = row.carrier;
        data.lineType = Number(row.lineType);
        console.log(data, '000000000');
      }
    },
    selectionLaneChange: function selectionLaneChange(row) {
      this.sailScheduleLaneDialogVisible = false;
      var data = this.form.webBkRoutingComs[this.currentIndex];
      data.vesselCode = row.vesselCode;
      data.vesselName = row.vesselName;
      data.voyageNo = row.voyageNo;
      data.voyageLeg = row.voyageLeg;
      data.tripNumber = this.currentIndex + 1;
      data.serviceLineCode = row.serviceLineCode;
      data.lineType = 1;
      if (!data.portFrom) {
        data.portFrom = this.form.webBkRoutingComs.length > 0 ? this.form.webBkRoutingComs[this.currentIndex - 1].portTo : '';
      }
      data.portTo = data.portTo ? data.portTo : '';
      data.etd = (0, _utils.parseTime)(row.etd, '{y}-{m}-{d} {h}:{i}:{s}');
      data.eta = '';
      data.carrier = 'SIT';
      data.polYard = '';
      data.podYard = '';
      data.id = '';
      data.rowStatus = 4;
    },
    selectionChangeOnBkRouting: function selectionChangeOnBkRouting(row) {
      this.bkRoutingSailScheduleDialogVisible = false;
      var data = this.form.webBkRoutingComs[this.currentIndex];
      data.vesselCode = row.vesselCode;
      data.vesselName = row.vesselName;
      data.voyageNo = row.voyageNo;
      data.voyageLeg = row.voyageLeg;
      data.tripNumber = this.currentIndex + 1;
      data.serviceLineCode = row.serviceLineCode;
      data.lineType = 1;
      if (!data.portFrom) {
        data.portFrom = this.form.webBkRoutingComs.length > 0 ? this.form.webBkRoutingComs[this.currentIndex - 1].portTo : '';
      }
      data.portTo = data.portTo ? data.portTo : '';
      data.etd = (0, _utils.parseTime)(row.etd, '{y}-{m}-{d} {h}:{i}:{s}');
      data.eta = '';
      data.carrier = 'SIT';
      data.polYard = '';
      data.podYard = '';
      data.id = '';
      data.rowStatus = 4;
    },
    // 中转
    handleAddTransfer: function handleAddTransfer() {
      var data = {
        tripNumber: this.form.webBkRoutingComs.length + 1,
        lineType: 1,
        serviceLineCode: '',
        vesselCode: '',
        vesselName: '',
        voyageNo: '',
        voyageLeg: '',
        portFrom: this.form.webBkRoutingComs.length > 0 ? this.form.webBkRoutingComs[this.form.webBkRoutingComs.length - 1].portTo : '',
        portTo: '',
        etd: '',
        eta: '',
        carrier: 'SIT',
        polYard: '',
        podYard: '',
        id: '',
        rowStatus: 4
      };
      this.form.webBkRoutingComs.push(data);
    },
    handleRemoveTransfer: function handleRemoveTransfer(row, index) {
      if (this.form.webBkRoutingComs.length === 1) {
        this.$message.warning(this.$t('home.deleteTip'));
        return;
      }
      if (row.bookingHeadWebComId || row.templateBookingHeadComId) {
        row.rowStatus = 8;
        this.form.deleteWebBkRoutingComs.push(row);
      }
      this.form.webBkRoutingComs.splice(index, 1);
    },
    // 危险品
    handleremoveTransferNew: function handleremoveTransferNew(row, index) {
      console.log('2222222222222222', row);
      if (this.form.webBkImoComs.length === 1) {
        this.$message.warning(this.$t('home.deleteTip'));
        return;
      }
      if (row.bkCargoWebComId || row.templateBkCargoComId) {
        console.log('2222222222222222', row);
        row.rowStatus = 8;
        this.form.deleteWebBkImoComs.push(row);
      }
      this.form.webBkImoComs.splice(index, 1);
    },
    handleAddTransferNew: function handleAddTransferNew() {
      // webBkImoComs
      var data = {
        classType: '',
        unSeriseNo: '',
        quantity: null,
        property: '',
        packageCode: '',
        emergencySeq: '',
        imoQuantity: null,
        grossWeight: null,
        netWeight: null,
        packagingCode: '',
        cargoSize: null,
        casNo1: '',
        casNo2: '',
        casNo3: '',
        temperature: null,
        intakeNum: '',
        contactName: '',
        contactNumber: '',
        contactTypeCode: '',
        approveKey: '',
        id: '',
        rowStatus: 4,
        componentDesc: '',
        emergencyTelNo: ''
      };
      this.form.webBkImoComs.push(data);
    },
    // 冷箱
    handleAddwebBkReeferComs: function handleAddwebBkReeferComs() {
      var data = {
        rateBase: '',
        temperature: null,
        maxTemperature: null,
        minTemperature: null,
        intakeNum: null,
        humidity: null
      };
      this.form.webBkReeferComs.push(data);
    },
    // 冷箱
    handleRemovewebBkReeferComs: function handleRemovewebBkReeferComs(row, index) {
      if (this.form.webBkReeferComs.length === 1) {
        this.$message.warning(this.$t('home.deleteTip'));
        return;
      }
      if (row.bkCargoWebComId || row.templateBkCargoComId) {
        row.rowStatus = 8;
        this.form.deleteWebBkReeferComs.push(row);
        console.log('this.form.deleteWebBkReeferComs', this.form.deleteWebBkReeferComs);
      }
      this.form.webBkReeferComs.splice(index, 1);
    },
    handleAddrfCheck: function handleAddrfCheck() {
      var data = {
        containerType: null,
        akLength: null,
        akWidth: null,
        akHigth: null,
        akGrossWeight: null,
        akNetWeight: null,
        quantity: null,
        commodityName: null,
        overFront: null,
        overAfter: null,
        overPortside: null,
        overStarboard: null,
        overHeight: null,
        isWallsFold: 0,
        isPointCover: 0,
        stowageRequired: null,
        specialLoadRequired: null,
        securingMethod: null,
        cellphone: null,
        oceanFreight: null,
        other: null
      };
      this.form.webBkAkComs.push(data);
    },
    handleRemoveCheck: function handleRemoveCheck(row, index) {
      if (this.form.webBkAkComs.length === 1) {
        this.$message.warning(this.$t('home.deleteTip'));
        return;
      }
      if (row.bookingHeadWebComId || row.templateBookingHeadComId) {
        row.rowStatus = 8;
        this.form.deleteWebBkAkComs.push(row);
      }
      this.form.webBkAkComs.splice(index, 1);
    },
    handleAddSoc: function handleAddSoc() {
      var data = {
        direction: '',
        returnToPort: '',
        returnToPortName: '',
        contactPerson: '',
        containerManager: 'SOC',
        fullEmptyType: '',
        containerSize: ''
      };
      this.form.webBkSocComs.push(data);
    },
    handleRemoveSoc: function handleRemoveSoc(row, index) {
      if (this.form.webBkSocComs.length === 1) {
        this.$message.warning(this.$t('home.deleteTip'));
        return;
      }
      if (row.bookingHeadWebComId || row.templateBookingHeadComId) {
        row.rowStatus = 8;
        this.form.deleteWebBkSocComs.push(row);
      }
      this.form.webBkSocComs.splice(index, 1);
      this.initDirection = this.form.webBkSocComs.some(function (val) {
        return val.direction === 1;
      }) ? 1 : 0;
    },
    handleAddHg: function handleAddHg() {
      var data = {
        containerType: '',
        quantity: null,
        type: '',
        rope: null,
        ties: null
      };
      this.form.webBkHgComs.push(data);
    },
    handleRemoveHg: function handleRemoveHg(row, index) {
      if (this.form.webBkHgComs.length === 1) {
        this.$message.warning(this.$t('home.deleteTip'));
        return;
      }
      if (row.bookingHeadWebComId || row.templateBookingHeadComId) {
        row.rowStatus = 8;
        this.form.deleteWebBkHgComs.push(row);
      }
      this.form.webBkHgComs.splice(index, 1);
    },
    judgeDirection: function judgeDirection(value) {
      this.initDirection = value;
    }
  }
};